import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { InstallPrompt } from "@/components/InstallPrompt";
import { Loader2 } from "lucide-react";

import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Gallery from "@/pages/Gallery";
import Customizer from "@/pages/Customizer";
import SendCard from "@/pages/SendCard";
import Recipient from "@/pages/Recipient";
import Dashboard from "@/pages/Dashboard";
import Advertise from "@/pages/Advertise";
import AdvertiseSuccess from "@/pages/AdvertiseSuccess";
import Admin from "@/pages/Admin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Reminders from "@/pages/Reminders";

function Protected({ children, admin }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center"><Loader2 className="w-8 h-8 animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/signup" element={<Auth mode="signup" />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/templates" element={<Gallery />} />
            <Route path="/reminders" element={<Reminders />} />
            <Route path="/create/:templateId" element={<Customizer />} />
            <Route path="/send/:greetingId" element={<SendCard />} />
            <Route path="/g/:token" element={<Recipient />} />
            <Route path="/advertise" element={<Advertise />} />
            <Route path="/advertise/success" element={<AdvertiseSuccess />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        <InstallPrompt />
      </AuthProvider>
    </div>
  );
}

export default App;
